import { useMemo, useState } from "react";
import { buildAlertsForPerson } from "../domain/buildAlertsForPersona";

// El cliente pidió expresamente que este aviso se base SOLO en la licencia de
// armas (ni seguro ni licencia de caza), con un horizonte fijo de 3 meses.
const HORIZON_DIAS = 90;

export function useAlertasTitularesViewModel(personas) {
    const [query, setQuery] = useState("");
    const [estado, setEstado] = useState("all");

    const alerts = useMemo(() => {
        const out = [];
        for (const p of personas) {
            const licArmasAlerts = buildAlertsForPerson(p, HORIZON_DIAS).filter((a) => a.tipo === "licArmas");
            out.push(...licArmasAlerts);
        }
        return out;
    }, [personas]);

    const filtered = useMemo(() => {
        const q = query.trim().toLowerCase();

        const out = alerts.filter((a) => {
            const hayTexto =
                !q ||
                (a.personName || "").toLowerCase().includes(q) ||
                (a.meta || "").toLowerCase().includes(q);
            if (!hayTexto) return false;

            return (
                estado === "all" ||
                (estado === "expired" && a.status === "expired") ||
                (estado === "soon" && a.status === "soon") ||
                (estado === "missing" && a.status === "missing")
            );
        });

        out.sort((A, B) => (A.daysLeft ?? 9e6) - (B.daysLeft ?? 9e6));
        return out;
    }, [alerts, query, estado]);

    const kpi = useMemo(() => {
        let cad = 0;
        let soon = 0;
        for (const a of filtered) {
            if (a.status === "expired") cad++;
            if (a.status === "soon") soon++;
        }
        return { total: filtered.length, cad, soon };
    }, [filtered]);

    return {
        horizonDias: HORIZON_DIAS,
        query, setQuery,
        estado, setEstado,
        filtered,
        kpi,
    };
}
